export const EMPTY_INPUT_STATE = Object.freeze({
  moveX: 0,
  moveY: 0,
  aimX: 0,
  aimY: 0,
  primary: false,
  secondary: false,
  melee: false,
  jump: false,
  boost: false,
  confirm: false,
  cancel: false,
  pause: false,
});

export const MOVEMENT_DEAD_ZONE = 0.16;

const KEY_ALIASES = {
  arrowleft: 'left',
  a: 'left',
  arrowright: 'right',
  d: 'right',
  arrowup: 'up',
  w: 'up',
  arrowdown: 'down',
  s: 'down',
  ' ': 'primary',
  spacebar: 'primary',
  enter: 'confirm',
  shift: 'secondary',
  shiftleft: 'secondary',
  shiftright: 'secondary',
  e: 'secondary',
  escape: 'cancel',
  p: 'pause',
};

export function createInputState(overrides = {}) {
  return {
    ...EMPTY_INPUT_STATE,
    ...overrides,
  };
}

export function getControlForKey(key) {
  return KEY_ALIASES[String(key).toLowerCase()] ?? null;
}

export function isInputKey(key) {
  return Boolean(getControlForKey(key));
}

export function getInputStateFromKeys(keys) {
  const pressed = new Set(Array.from(keys, (key) => getControlForKey(key)).filter(Boolean));
  const moveX = Number(pressed.has('right')) - Number(pressed.has('left'));
  const moveY = Number(pressed.has('down')) - Number(pressed.has('up'));
  const secondary = pressed.has('secondary');

  return createInputState({
    moveX,
    moveY,
    primary: pressed.has('primary'),
    secondary,
    boost: secondary,
    confirm: pressed.has('confirm') || pressed.has('primary'),
    cancel: pressed.has('cancel'),
    pause: pressed.has('pause') || pressed.has('cancel'),
  });
}

export function mergeInputState(baseInput, partialInput) {
  return createInputState({
    ...baseInput,
    ...partialInput,
  });
}

export function movementFlagsFromInput(input, deadZone = MOVEMENT_DEAD_ZONE) {
  return {
    left: input.moveX < -deadZone,
    right: input.moveX > deadZone,
    up: input.moveY < -deadZone,
    down: input.moveY > deadZone,
  };
}
